import { SEND_MESSAGE } from "../actions/WaitResult";
import { EventLogService } from '../../services/EventLogService';

export default store => next => (action) => {
	const { payload } = action;
	switch (action.type) {

        case SEND_MESSAGE: {
            EventLogService.createLog(payload.sender, payload.senderID, payload.message, payload.isSuccess ? 1 : 4, payload.data);
            EventLogService.createNotify(payload.isSuccess, payload.message, payload.data );
            return next(action);
        }
            
    }

	return next(action)
}
